import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertTriangle, Lock, X } from 'lucide-react';
interface SnapshotConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  month: string;
  year: number;
  avpCount: number;
}
export function SnapshotConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  month,
  year,
  avpCount
}: SnapshotConfirmModalProps) {
  const [isChecked, setIsChecked] = useState(false);
  // Reset state when opened
  useEffect(() => {
    if (isOpen) setIsChecked(false);
  }, [isOpen]);
  return <AnimatePresence data-id="element-316">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/60 backdrop-blur-sm z-40" onClick={onClose} data-id="element-317" />
          <div className="fixed inset-0 flex items-center justify-center z-50 p-4 pointer-events-none" data-id="element-318">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="glass-panel bg-[#0f1423] rounded-3xl p-8 max-w-md w-full shadow-2xl pointer-events-auto border border-indigo-500/20 relative overflow-hidden" data-id="element-319">
              {/* Decorative background glow */}
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-32 bg-indigo-500/10 blur-3xl rounded-full pointer-events-none" data-id="element-320" />

              <button onClick={onClose} className="absolute top-4 right-4 text-slate-400 hover:text-white transition-colors" data-id="element-321">
                <X className="w-5 h-5" data-id="element-322" />
              </button>

              <div className="flex flex-col items-center text-center mb-6 relative z-10" data-id="element-323">
                <div className="w-16 h-16 rounded-2xl bg-rose-500/10 border border-rose-500/20 flex items-center justify-center mb-4 text-rose-400" data-id="element-324">
                  <Lock className="w-8 h-8" data-id="element-325" />
                </div>
                <h2 className="text-2xl font-bold text-white mb-2" data-id="element-326">
                  Stamp Monthly Snapshot
                </h2>
                <p className="text-slate-400 text-sm" data-id="element-327">
                  You are about to finalize the performance records for{' '}
                  <strong className="text-white" data-id="element-328">
                    {month} {year}
                  </strong>
                  .
                </p>
              </div>

              <div className="bg-black/20 rounded-xl p-4 mb-6 border border-white/5" data-id="element-329">
                <div className="flex justify-between items-center mb-2" data-id="element-330">
                  <span className="text-slate-400 text-sm" data-id="element-331">
                    Total Leaders Included
                  </span>
                  <span className="text-white font-semibold" data-id="element-332">
                    {avpCount} AVPs
                  </span>
                </div>
                <div className="flex justify-between items-center" data-id="element-333">
                  <span className="text-slate-400 text-sm" data-id="element-334">Status</span>
                  <span className="text-amber-400 text-sm font-medium flex items-center gap-1" data-id="element-335">
                    <AlertTriangle className="w-4 h-4" data-id="element-336" /> Pending Finalization
                  </span>
                </div>
              </div>

              <div className="mb-8" data-id="element-337">
                <label className="flex items-start gap-3 cursor-pointer group" data-id="element-338">
                  <div className="relative flex items-center justify-center mt-0.5" data-id="element-339">
                    <input type="checkbox" className="peer sr-only" checked={isChecked} onChange={e => setIsChecked(e.target.checked)} data-id="element-340" />
                    <div className="w-5 h-5 rounded border-2 border-slate-500 peer-checked:border-indigo-500 peer-checked:bg-indigo-500 transition-colors" data-id="element-341" />
                    <svg className="absolute w-3 h-3 text-white opacity-0 peer-checked:opacity-100 transition-opacity pointer-events-none" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-342">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-343" />
                    </svg>
                  </div>
                  <span className="text-sm text-slate-300 group-hover:text-slate-200 transition-colors" data-id="element-344">
                    I understand that stamping this snapshot will permanently
                    preserve these metrics and rankings. This action cannot be
                    undone.
                  </span>
                </label>
              </div>

              <div className="flex gap-3" data-id="element-345">
                <button onClick={onClose} className="flex-1 px-4 py-2.5 rounded-xl glass-panel hover:bg-white/10 text-white font-medium transition-colors" data-id="element-346">
                  Cancel
                </button>
                <button disabled={!isChecked} onClick={onConfirm} className="flex-1 px-4 py-2.5 rounded-xl bg-gradient-to-r from-indigo-600 to-violet-600 hover:from-indigo-500 hover:to-violet-500 text-white font-semibold shadow-lg disabled:opacity-50 disabled:cursor-not-allowed transition-all" data-id="element-347">
                  Confirm & Stamp
                </button>
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}